import { getReqMessage } from '../../../utils/formValidation/errorMessageFunctions';

export const initialErrorState = {};

export const validate = (newEntry) => {
    let newErrors = {};

    if (!newEntry.assigneeId) {
        newErrors = {
            ...newErrors,
            assigneeId: { error: true, message: getReqMessage('Claim Item Assignee') }
        };
    }

    return newErrors;
};
